export default __webpack_public_path__ + "static/illustration-content-rect.url-24f5e59120905fe312a4f49970b2726f.svg";